import * as React from 'react';
import { ProjectWizard } from './wizard';
import { CreateProjectOptionDialog } from './option-dialog';
import { ProjectCuHandler } from '../project-cu-handler';
import type { PROJECT_TYPE } from '@/types';

interface CreationWizardManagerProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    projectType: PROJECT_TYPE;
    onCreated?: (projectId: number) => Promise<void> | void;
}

export const CreationWizardManager: React.FC<CreationWizardManagerProps> = ({
    open,
    onOpenChange,
    projectType,
    onCreated,
}) => {
    const [showOptionDialog, setShowOptionDialog] = React.useState(false);
    const [showWizard, setShowWizard] = React.useState(false);
    const [showStandard, setShowStandard] = React.useState(false);

    React.useEffect(() => {
        if (open) {
            setShowOptionDialog(true);
        }
    }, [open]);

    const handleOptionSelect = (option: 'wizard' | 'standard') => {
        setShowOptionDialog(false);
        if (option === 'wizard') {
            setShowWizard(true);
        } else {
            setShowStandard(true);
        }
    };

    const handleOptionDialogChange = (isOpen: boolean) => {
        setShowOptionDialog(isOpen);
        if (!isOpen && !showWizard && !showStandard) {
            onOpenChange(false);
        }
    };

    const handleWizardChange = (isOpen: boolean) => {
        setShowWizard(isOpen);
        if (!isOpen) {
            onOpenChange(false);
        }
    };

    const handleStandardChange = (isOpen: boolean) => {
        setShowStandard(isOpen);
        if (!isOpen) {
            onOpenChange(false);
        }
    };

    return (
        <>
            <CreateProjectOptionDialog
                open={showOptionDialog}
                onOpenChange={handleOptionDialogChange}
                onSelect={handleOptionSelect}
            />
            <ProjectWizard
                open={showWizard}
                defaultType={projectType}
                onOpenChange={handleWizardChange}
                onCreated={onCreated}
                onComplete={(type) => {
                    if (type) {
                        window.dispatchEvent(new CustomEvent('switch-project-tab', {
                            detail: type.toLowerCase()
                        }));
                    }
                    setShowWizard(false);
                    onOpenChange(false);
                }}
                onSkipToStandard={() => {
                    setShowWizard(false);
                    setShowStandard(true);
                }}
            />
            <ProjectCuHandler
                openFor="create"
                projectType={projectType}
                open={showStandard}
                setOpen={handleStandardChange}
                setOpenFor={() => { }}
                onCreated={onCreated}
            />
        </>
    );
};
